/**
 * @file 选择质押币种相关hook
 */
import { useState, useEffect } from 'react';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { getTokenBalance } from '@/services/wallet';
import { PriceInfo } from '@/types/common';
import { getAddress } from '@/utils/common';
import { useCurrentChainAddress } from '@/hooks/wallet';

/**
 * 获取质押币种的价格
 */
export const useCoinPrice = () => {
  const { poolInfo } = usePoolInfoContext();
  const [isLoading, setIsLoading] = useState(true);
  const { walletAddress } = useCurrentChainAddress(poolInfo.chainCode);
  const [priceCoinStore, setCoinPriceStore] = useState<
    Record<string, PriceInfo>
  >({});

  const fetchCoinPrice = async () => {
    const balanceInfoList = await Promise.all(
      poolInfo.whiteList.map(async (coinInfo) => {
        const { result } = await getTokenBalance({
          chainId: poolInfo.chainId,
          tokenAddress: getAddress(coinInfo.contractAddress),
          walletAddress,
        });
        return {
          ...result,
          // 余额接口的本币contract为空，所以使用coinInfo的
          contract: coinInfo.contractAddress,
        };
      })
    );

    const newPriceStore: Record<string, PriceInfo> = {};

    balanceInfoList.forEach((balanceInfo) => {
      newPriceStore[`${balanceInfo.chainCode}${balanceInfo.contract}`] = {
        amount: balanceInfo.balance,
        value: balanceInfo.balanceUsd,
      };
    });

    setCoinPriceStore(newPriceStore);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchCoinPrice();
  }, []);

  return {
    isLoading,
    priceCoinStore,
  };
};
